import { Directive, HostListener, Input, NgModule } from '@angular/core';

import { InfoModalsService } from '~app-client/info-modals/services';
import { InfoModalKey } from '~app-client/info-modals/types';

@Directive({
	standalone: false,
	selector: '[infoModalButton]',
})
export class InfoModalButtonDirective {
	@Input('infoModalButton')
	public infoModalKey?: InfoModalKey;

	constructor(private readonly service: InfoModalsService) {}

	@HostListener('click')
	public _onClick(): void {
		if (this.infoModalKey) {
			this.service.openModal(this.infoModalKey);
		}
	}
}

@NgModule({
	declarations: [InfoModalButtonDirective],
	exports: [InfoModalButtonDirective],
})
export class InfoModalButtonDirectiveModule {}
